import en_US from './en-US.json';

export const messages = {
  'en-US': en_US
};

export const locale = 'en-US';
